"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploader = exports.dsc = exports.default = exports.___ = void 0;
require("core-js/modules/web.dom.iterable");
require("./ModelGraph");
require("./Uploader");
require("./DaoServiceClient");
require("./TaskMessageNotify");
var _DaoServiceClientConfig = _interopRequireDefault(require("./DaoServiceClientConfig"));
var _requestDs = _interopRequireDefault(require("../requestDs"));
/**
 * @namespace ds
 */
var ds = window.ds.noConflict();
var taskMessenger = ds.taskMessenger,
  createUploader = ds.createUploader;

// var client = createDaoServiceClient();

function getAutoApiUrl(client, req) {
  return client.serverUrl + client.projectId + '/' + 'auto-api/' + req.mainModelName + '/' + req.action + '/' + client.serviceCode + '/' + req.tag;
}

/**
 * 自动生成标签
 *
 * @param {Object} req 请求参数对象
 * @return {string} tag
 */
function autoTagging(req) {
  return "DS_".concat(req.projectKey, "_").concat(req.modelName, "_").concat(req.action);
}
ds.types.DaoServiceClient.prototype.execute = function () {
  var requestBody = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!requestBody.projectKey) {
    requestBody.projectKey = this.projectKey;
  }
  if (!requestBody.tag) {
    requestBody.tag = autoTagging({
      projectKey: requestBody.projectKey,
      modelName: requestBody.mainModelName,
      action: requestBody.action
    });
  }
  var url = getAutoApiUrl(this, requestBody);
  // console.log(`\r\nPOST ${url}\r\nContent-Type: application/json\r\n\r\n${JSON.stringify(requestBody)}`);
  return _requestDs.default.post(url, requestBody, {
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then(function (response) {
    if (response.debugInfo && console.log) {
      // console.log(`%c数据服务请求 "${requestBody.tag}" 执行的SQL有: `, 'color: red; font-style: italic');
      response.debugInfo.forEach(function (line) {
        // console.log(line);
      });
    }
    return response;
  });
};
ds.types.DaoServiceClient.prototype.promiseResolved = function (response) {
  return Promise.resolve(response);
};

/**
 * 自动构建 client
 */
(function () {
  if (_DaoServiceClientConfig.default.hasOwnProperty('_default')) {
    ds.client.config(_DaoServiceClientConfig.default['_default']);
  }
  for (var clientName in _DaoServiceClientConfig.default) {
    if (_DaoServiceClientConfig.default.hasOwnProperty(clientName) && clientName !== '_default') {
      ds[clientName] = new ds.types.DaoServiceClient();
      ds[clientName].config(_DaoServiceClientConfig.default[clientName]);
    }
  }
})();
var SelectCollectCommand = ds.types.SelectCollectCommand;

/**
 * 自动填充表格参数到查询模式
 *
 * @param selectPattern {SelectCollectCommand} 执行模式
 * @param sorter 排序参数
 * @param pagination
 * @param [filterArgs] 查询参数 <b>暂未实现</b>
 * @param [sorter.order]
 * @param [sorter.field]
 */
SelectCollectCommand.fillConditionFromAntdTable = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    sorter = _ref.sorter,
    pagination = _ref.pagination;
  var resultExpression;
  var me = this;
  if (sorter && sorter.field) {
    var order = sorter.field;
    if (sorter.order === 'descend') {
      order += ' DESC';
    }
    me.orders = [order];
  }
  if (pagination) {
    resultExpression = me.paging(pagination.current, pagination.pageSize);
  }
  return resultExpression;
};

// 任务提示消息示例
function onTaskMessage(task) {
  var title = (task.taskType.toUpperCase() === 'IMPORT' ? '导入' : '导出') + '消息提示';
  console.info(title);
}
taskMessenger.config({
  timerInterval: 10000 * 1000,
  onTaskMessage: onTaskMessage
});
function onFileUploadOk(data) {
  console.info(data);
}
function onFileUploadFail(data) {
  console.info(data);
}
function startCallback(data) {
  console.info(data);
}
function progressCallback(data) {
  console.info(data);
}

// 创建新fileUploader
var fileUploader = createUploader();
fileUploader.setOption({
  action: "".concat(window.backend_ctx, "/daoService/excelImport/test"),
  // 上传接口
  filter: '',
  // 文件类型过滤器
  maxsize: 10,
  // 文件上传大小限制，单位：M
  params: {
    test: 'test',
    id: 123
  },
  // 请求参数
  startCallback: startCallback,
  // 开始上传的回调函数
  progressCallback: progressCallback,
  // 上传进度回调函数
  successCallback: onFileUploadOk,
  // 上传成功回调函数
  errorCallback: onFileUploadFail // 上传错误的回调函数
});

/**
 * 上传客户端
 */
var uploader = exports.uploader = fileUploader;

/**
 * 数据服务客户端实例
 * @type ds.DaoServiceClient
 */
var dsc = exports.dsc = ds.client;

/**
 * 参数名与字段名一致时的简写
 * @type {SameWithFieldNamedParameter} 与字段名相同的具名参数
 * @private
 */
var ___ = exports.___ = dsc.___;
var _default = exports.default = ds;